import colors from "../colors";

export default colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale-chromatic/src/categorical/Pastel2.js
// module id = QfGF
// module chunks = 0